import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	StyledContainer,
	StyledLink,
	Copyright,
	Payment,
	Image,
	PaymentDiv
} from './styles';
import { policies, paymentMethods } from '../../../../../utils';

const LegalWarning = () => {
	const { t, i18n } = useTranslation();
	const year = new Date().getFullYear();

	const getList = () =>
		policies.map(policy => (
			<StyledLink
				key={policy.title}
				href={i18n.language === 'es' ? policy.pdfES : policy.pdfEN}
				role='button'
				target='_blank'
				rel='noopener noreferrer'
				color={'textPrimary'}
			>
				{t(policy.title)}
			</StyledLink>
		));

	const getPaymentMethods = () =>
		paymentMethods.map((payment, index) => (
			<Image key={`${payment}-${index}`} src={payment} alt='' />
		));
	return (
		<StyledContainer>
			<div>{getList()}</div>
			<PaymentDiv>
				<Payment variant='body1' color={'textPrimary'}>
					{t('legalWarning.payments')}
				</Payment>
				<div>{getPaymentMethods()}</div>
			</PaymentDiv>
			<div>
				<Copyright
					variant='body1'
					color={'textPrimary'}
					className={'copyright-symbol'}
				>
					{t('legalWarning.copyright', { year })}
				</Copyright>
				<Copyright variant='body1' color={'textPrimary'}>
					{t('legalWarning.copyrightTitle')}
				</Copyright>
			</div>
		</StyledContainer>
	);
};

export default LegalWarning;
